import { useTranslation as usei18NextTranslation } from 'react-i18next';

export function useTranslation() {
  return usei18NextTranslation();
}
